import * as React from 'react';
import { useFormikContext } from 'formik';
import { Label } from './Label';
import { IFormValues } from '../DealRentModal';
import { useFieldHasErrors } from './utils';
import { CountComponent } from '../../CountComponent';
import * as styles from '../index.css';

export const Persons = () => {
  const { values, setFieldValue } = useFormikContext<IFormValues>();
  const invalid = useFieldHasErrors('personsCount');
  const onChange = React.useCallback((value: number) => setFieldValue('personsCount', value), [setFieldValue]);

  return (
    <div className={styles['field']}>
      <Label invalid={invalid}>Взрослых</Label>
      <CountComponent min={1} max={100} value={values['personsCount'] || 0} onChange={onChange} />
    </div>
  );
};
